export default function useReportDownloadForm() {



    const reportDataConstructor = (data)=> {

        return {
            'id': data.id,
            'filterfield_set': data.filterfield_set
        }

    };

    const requestDataConstructor = (initialData, formData) => {


        if (initialData !== formData && Object.keys(formData).length > 0) {

            let filterfield_set = formData['filterfield_set'] || {};

            return filterfield_set.length === 0 ? {} : {"filterfield_set": filterfield_set}

        }

        return {}
    };

    return {
        reportDataConstructor,
        requestDataConstructor,
    }
}
